import { FC } from 'react';
import { observer } from 'mobx-react';
import AppLayout from "modules/owners/containers/Single/components/Layout";
import ownerStore from 'stores/owner';
import Notes from 'submodules/notes/containers/index';


const OwnerNotes: FC = observer(() => {
  const owner: any = ownerStore.selected;

  return (
    <AppLayout>
      <Notes resource_type='Owner' resource={owner} />
    </AppLayout>
  );
})

export default OwnerNotes;
